import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'shop.cart.title',
    defaultMessage: 'Shopping Cart',
  },
  checkoutCTA: {
    id: 'shop.cart.checkoutCTA',
    defaultMessage: 'Checkout',
  },
  continueShoppingCTA: {
    id: 'shop.cart.continueShoppingCTA',
    defaultMessage: 'Continue Shopping',
  },
  emptyCartMessage: {
    id: 'shop.cart.emptyCartMessage',
    defaultMessage: 'Shopping cart is empty.',
  },
  emptyCartCTA: {
    id: 'shop.cart.emptyCartCTA',
    defaultMessage: 'Continue shopping',
  },
  alertOutOfStockTitle: {
    id: 'shop.cart.alertOutOfStockTitle',
    defaultMessage: '{productName} is Out of Stock',
  },
  alertOutOfStockMessage: {
    id: 'shop.cart.alertOutOfStockMessage',
    defaultMessage:
      'The product you selected went out of stock. Please remove the item in order to proceed to checkout.',
  },
  alertOutOfStockActionRemove: {
    id: 'shop.cart.alertOutOfStockActionRemove',
    defaultMessage: 'Remove item',
  },
});
